import { Directive, HostBinding, Input, OnChanges } from '@angular/core';
import { SessionService } from '@core/session.service';

@Directive({
  // eslint-disable-next-line @angular-eslint/directive-selector
  selector: 'a[href]',
  standalone: true,
})
export class LanguagePathDirective implements OnChanges {
  @HostBinding('attr.href') hrefAttr = '';
  @Input() href: string;

  constructor(private readonly sessionService: SessionService) {}

  ngOnChanges(): void {
    this.hrefAttr = this.sessionService.appendLanguagePath(this.href);
  }
}
